<template>
  <ZMainPage type="card" :loading="loading">
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">基础信息</span>
      </div>
      <LineWrapper list column="3" label-width="170rem">
        <LineItem v-for="item in list1" :key="item.label" :label="item.label">
          <span class="mr-1" v-if="item.value">{{ item.value }}</span>
          <span class="text-primary c-p" v-if="item.button" @click="handlePreview(item.type)">{{ item.button }}</span>
        </LineItem>
        <image-viewer :visible.sync="imageVisible" :list="[score_image]" />
      </LineWrapper>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text mr-2">缴费详情</span>
        <template v-if="tag.length">
          <ZuTips v-if="item.name" :value="item.name" :type="item.type === 1 ? 'red' : 'orange'" v-for="(item, idx) in tag" :key="idx" />
        </template>
      </div>
      <LineWrapper list column="3" labelWidth="180rem">
        <LineItem class="item" v-for="item in list2" :key="item.label" :label="item.label" :value="item.value"></LineItem>
      </LineWrapper>
      <div class="table-wrap">
        <CustomTable :data="data" :config="config" type="orange" emptySrc="/img/data-o.png" :radius="true" @action="handleAction" />
      </div>
    </div>
    <Dialog :visible.sync="dialogVisible" :title="title" size="big" :showFooter="false">
      <template v-if="dialogType === 1">
        <LineWrapper list column="3">
          <LineItem :label="item.label" :value="item.value" v-for="item in dialogList" :key="item.label"></LineItem>
        </LineWrapper>
        <div class="pb-2"></div>
        <CustomTable :data="dialogListData1" :config="dialogListConfig1" headerBgColor="#CBE4FF" titleBgColor="#CBE4FF" headerColor="#333" :radius="false"></CustomTable>
        <CustomTable v-if="dialogListData2.length" :data="dialogListData2" :config="dialogListConfig2" headerBgColor="#CBE4FF" titleBgColor="#CBE4FF" headerColor="#333" :radius="false"></CustomTable>
      </template>
      <template v-else-if="dialogType === 2">
        <CustomTable border :data="dialogListData3" :config="dialogListConfig3"></CustomTable>
      </template>
    </Dialog>
    <Dialog :visible.sync="approveVisible" :loading="approveLoading" title="审批" size="large" buttonAlign="center" :closeOnClickModal="false" :beforeClose="onBeforeClose">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="140rem" label-position="left">
        <el-row class="flex flex-wrap">
          <el-col span="24">
            <el-form-item label="订单状态"><span style="color: #F53F3F;">{{ status_text }}</span></el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="分期项">{{ category_name }}</el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="本期应缴金额">{{ money_answer }}</el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="是否有特批优惠" prop="is_offline_discount">
              <el-select v-model="formData.is_offline_discount" placeholder="请选择" @change="onSpecialTypeChange">
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <template v-if="formData.is_offline_discount === 1">
            <el-col span="8">
              <el-form-item style="margin-bottom: 0;"></el-form-item>
              <el-form-item label="特批优惠金额" prop="money_offline_discount">
                <el-input v-model="formData.money_offline_discount" placeholder="请输入" @change="onSpecialPriceChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item style="margin-bottom: 0;"></el-form-item>
              <el-form-item label="实际应缴金额" prop="money_answer_actual_total">
                <el-input v-model="formData.money_answer_actual_total" disabled placeholder="请输入特批优惠金额"></el-input>
              </el-form-item>
            </el-col>
          </template>
          <el-col span="8">
            <el-form-item label="是否再次分期" prop="is_by_stages_again">
              <el-select v-model="formData.is_by_stages_again" placeholder="请选择是否分期" @change="onStageChange">
                <el-option v-for="item in stagesOptions" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <template v-if="formData.is_by_stages_again">
            <el-col span="8">
              <el-form-item style="margin-bottom: 0;"></el-form-item>
              <el-form-item label="本期实缴金额" prop="money_actual">
                <el-input v-model="formData.money_actual" placeholder="请输入" :maxlength="30" @change="onAmountChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item style="margin-bottom: 0;"></el-form-item>
              <el-form-item label="欠缴金额" prop="money_to_pay">
                <el-input v-model="formData.money_to_pay" disabled placeholder="请输入本期实缴金额"></el-input>
              </el-form-item>
            </el-col>
          </template>
          <template v-else-if="formData.is_by_stages_again === 0">
            <el-col span="8">
              <el-form-item label="本期实缴金额">{{ sj }}</el-form-item>
            </el-col>
          </template>
          <template v-if="formData.is_by_stages_again === 2">
            <el-col span="8">
              <el-form-item style="margin-bottom: 0;"></el-form-item>
              <el-form-item label="分期每期应缴金额" prop="money_installment_average">
                <el-input v-model="formData.money_installment_average" placeholder="请输入分期每期应缴金额" @input="onInstallmentChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item style="margin-bottom: 0;"></el-form-item>
              <el-form-item label="分期期数" prop="money_installment_count">
                <el-input v-model="formData.money_installment_count" disabled placeholder="请输入分期每期应缴金额"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="20" v-if="installmentConfig.length">
              <el-form-item label="">
                <CustomTable :config="installmentConfig" :data="installmentData" border />
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <el-form-item v-if="showMethod" label="实缴金额及方式" class="z-no-margin-bottom mb-2">
          <div class="z-dynamic-list-item" v-for="(domain, index) in formData.payment_detail" :key="domain.id">
            <div class="flex z-dynamic-list-inner">
              <el-form-item labelWidth="0" :prop="`payment_detail.${index}.paid_amount`" :rules="dynamicNumber">
                <el-input v-model="domain.paid_amount" placeholder="请输入学生缴费金额"></el-input>
              </el-form-item>
              <div class="px-1 text-gray">-</div>
              <el-form-item labelWidth="0" :prop="`payment_detail.${index}.payment_method`" :rules="dynamicSelect">
                <el-select v-model="domain.payment_method" placeholder="请选择学生缴费方式">
                  <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <div class="px-1 text-gray">-</div>
              <el-form-item labelWidth="0" :prop="`payment_detail.${index}.payer`" :rules="dynamicInput">
                <el-input v-model="domain.payer" placeholder="请输入付款人姓名" maxlength="20"></el-input>
              </el-form-item>
              <div class="px-1 text-gray">-</div>
              <el-form-item :prop="`payment_detail.${index}.payment_at`" :rules="dynamicData" labelWidth="0">
                <el-date-picker v-model="domain.payment_at" placeholder="请选择缴费时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>
            </div>
            <el-form-item label-width="40rem">
              <el-button icon="el-icon-delete" circle v-if="formData.payment_detail.length !== 1" @click.prevent="handelRemove(domain)"></el-button>
              <el-button icon="el-icon-plus" circle v-if="formData.payment_detail.length !== dynamicMaxlength && index === formData.payment_detail.length - 1" @click="handleAdd"></el-button>
            </el-form-item>
          </div>
          <ZuTips :value="sumAmount" type="info" showIcon />
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="formData.reason" placeholder="请输入" :maxlength="300" show-word-limit :autosize="{ minRows: 8, maxRows: 20}"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="submit('ruleForm')">通过</el-button>
        <el-button type="warning" @click="submit('ruleForm', false)">暂存</el-button>
        <el-button @click="onClose">关闭</el-button>
      </template>
    </Dialog>
    <Dialog :visible.sync="viewVisible" title="查看" size="large" buttonAlign="center">
      <LineWrapper list column="3" label-width="130rem">
        <LineItem v-for="item in viewList1" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle" :color="item.color"></LineItem>
      </LineWrapper>
      <template v-if="dialogConfig.length">
        <LineWrapper list column="1">
          <LineItem label="">
            <div style="width: 1000rem">
              <CustomTable :config="dialogConfig" :data="dialogData" border />
            </div>
          </LineItem>
        </LineWrapper>
      </template>
      <template>
        <LineWrapper v-if="viewData.length" list column="3" labelWidth="130rem">
          <LineItem label="实缴金额及方式">
            <div style="width: 700rem;">
              <CustomTable :data="viewData" :config="viewConfig" type="gray" />
              <ZuTips class="mt-2" :value="viewSumAmount" type="info" showIcon />
            </div>
          </LineItem>
        </LineWrapper>
        <LineWrapper v-if="viewList2.length" list labelWidth="130rem">
          <LineItem label="备注" v-for="item in viewList2" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle"></LineItem>
        </LineWrapper>
        <div v-if="viewList3.length" class="mt-3 pb-2" style="border-top: solid 1rem #F2F2F2;"></div>
        <LineWrapper v-if="viewList3.length" list column="3">
          <LineItem class="item" v-for="item in viewList3" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle"></LineItem>
        </LineWrapper>
      </template>
      <template #footer>
        <el-button @click="viewVisible = false">关闭</el-button>
      </template>
    </Dialog>
    <template #footer>
      <el-button :disabled="loading" @click="$router.back()">返回</el-button>
    </template>
  </ZMainPage>
</template>

<script>
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
import ImageViewer from '@/components/common/ImageViewer'
import Dialog from '@/components/common/Dialog'
import CustomTable from "@/components/common/CustomTable"
import ZuTips from "@/components/common/ZuTips"
import ZuSpecialTable from "@/views/finance/enrollment/offline-payment-approval/components/ZuSpecialTable"
import ZuInstallmentTable from "@/views/finance/enrollment/offline-payment-approval/components/ZuInstallmentTable"
import ZuEmpty from '@/components/common/ZuEmpty.vue'
import { formDataBackMixin } from '@/utils/mixins'
import { formatDate, preciseAdd, preciseSubtract, preciseMultiply, preciseDivide, objectIsEmpty, numberToChinese, transformAddOrEditData } from '@/utils'
import { validateNumber, verifyIsNumber } from '@/utils/validate'
import { orderPayMethod } from '@/utils/data'
import http from '@/api'
export default {
  _config:{'route':{'path':'edit','meta':{'title':'审批'}}},
  components: { LineWrapper, LineItem, ImageViewer, Dialog, CustomTable, ZuTips, ZuSpecialTable, ZuInstallmentTable, ZuEmpty },
  mixins: [formDataBackMixin],
  data() {
    const validateS = (rule, value, callback) => {
      if (value === '') return callback(new Error('请输入特批优惠金额'))
      const num1 = Number(this.money_answer)
      const num2 = Number(value)
      if (num2 > num1) return callback(new Error('特批优惠金额需要小于等于本期应缴金额'))
      validateNumber(value, callback, { min: 0, max: num1, equalToMin: false, equalToMax: true })
    }
    const validateA = (rule, value, callback) => {
      const v = verifyIsNumber(value, { empty: '请输入本期实缴金额', positive: true })
      if (v) return callback(new Error(v))
      let str = ''
      const num1 = Number(this.formData.is_offline_discount ? this.formData.money_answer_actual_total : this.money_answer)
      const num2 = Number(value)
      if (num2 >= num1) {
        str = `实缴金额需要小于${this.formData.is_offline_discount ? '实际应缴金额' : '本期应缴金额'}`
      }
      if (str) return callback(new Error(str))
      callback()
    }
    const validateP = (_r, value, callback) => {
      const v = verifyIsNumber(value, { empty: '请输入分期每期应缴金额', positive: true  })
      if (v) return callback(new Error(v))
      const n1 = Number(this.formData.money_to_pay)
      validateNumber(value, callback, { min: 0, max: n1 })
    }
    const validateI = (_r, value, callback) => {
      const v = verifyIsNumber(value, { empty: '请输入分期每期应缴金额', positive: true })
      if (v) return callback(new Error(v))
      if (Number(value) > 12) return callback('超出最大分期限额，分期期数不能超过12期')
      callback()
    }
    return {
      id: '',
      loading: false,
      score_image: '',
      imageVisible: false,
      dialogVisible: false,
      approveVisible: false,
      approveLoading: false,
      viewVisible: false,
      title: '',
      dialogType: 0,
      list1: [],
      list2: [],
      data: [],
      config: [],
      tag: [],
      dialogList: [],
      dialogListData1: [],
      dialogListConfig1: [],
      dialogListData2: [],
      dialogListConfig2: [],
      dialogListData3: [],
      dialogListConfig3: [],
      dynamicMaxlength: 15,
      money_answer: 0,
      status_text: '',
      category_name: '',
      info: {},
      stagesOptions: [],
      installmentConfig: [],
      installmentData: [],
      dialogConfig: [],
      dialogData: [],
      formData: {
        is_offline_discount: 0,
        money_offline_discount: '',
        money_answer_actual_total: '',
        money_installment_average: '',
        money_installment_count: '',
        is_by_stages_again: 0,
        money_actual: '',
        money_to_pay: '',
        pay_time: '',
        payment_detail: [],
        reason: ''
      },
      rules: {
        money_offline_discount: [{ required: true, validator: validateS, trigger: 'blur' }],
        money_installment_average: [{ required: true, validator: validateP, trigger: 'change' }],
        money_installment_count: [{ required: true, validator: validateI, trigger: 'change' }],
        is_by_stages_again: [{ required: true, message: '请选择是否再次分期', trigger: 'change' }],
        money_actual: [{ required: true, validator: validateA, trigger: 'blur' }],
        money_to_pay: [{ required: true, message: '请输入本期实缴金额', trigger: 'blur' }],
        pay_time: [{ required: true, message: '请选择缴费时间', trigger: 'change' }]
      },
      dynamicSelect: { required: true, message: '请选择学生缴费方式', trigger: 'change' },
      dynamicInput: { required: true, message: '请输入付款人姓名', trigger: 'blur' },
      dynamicData: {required: true, message: '请选择缴费时间', trigger: 'blur'},
      dynamicNumber: { required: true, validator: (_, value, callback) => validateNumber(value, callback, { min: 0, equalToMin: true, empty: '请输入学生缴费金额' }), trigger: 'blur' },
      viewList1: [],
      viewList2: [],
      viewList3: [],
      viewData: [],
      viewConfig: [],
      viewSumAmount: '',
      is2026Order: false
    }
  },
  computed: {
    showMethod() {
      // 不分期 实际应缴金额为0
      if(!this.formData.is_by_stages_again && this.formData.money_answer_actual_total !== '') {
        if (Number(this.formData.money_answer_actual_total) === 0) return false
      }
      // 部分欠缴 按期交费  本期实缴金额为0
      if(this.formData.is_by_stages_again && this.formData.money_actual !== '') {
        if (Number(this.formData.money_actual) === 0) return false
      }
      return true
    },
    sj() {
      if (this.formData.is_by_stages_again) return 0
      return preciseSubtract(this.money_answer, Number(this.formData.money_offline_discount) || 0)
    },
    sumAmount() {
      const arr = this.formData.payment_detail.filter(i => i.paid_amount)
      const sum = arr.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount) || 0), 0)
      if (isNaN(sum)) {
        return '请输入数字'
      }
      return `累计实缴金额：${sum}`
    }
  },
  created() {
    this.getConfig()
    this.getData()
  },
  methods: {
    onSpecialTypeChange() {
      this.formData.money_offline_discount = ''
      this.formData.money_answer_actual_total = ''
      this.formData.money_actual = ''
      this.formData.money_to_pay = ''
      this.formData.is_by_stages_again = 0
      this.formData.money_installment_average = ''
      this.formData.money_installment_count = ''
      this.formData.money_installment_count = ''
      this.installmentConfig = []
      this.installmentData = []
    },
    onSpecialPriceChange(val) {
      if (verifyIsNumber(val, { empty: '请输入特批优惠金额', positive: true })) {
        this.formData.money_answer_actual_total = ''
        return
      }
      let v1 = Number(val)
      let v2 = Number(this.money_answer)
      if (v1 > v2) {
        this.formData.money_answer_actual_total = ''
        return
      }
      this.formData.money_answer_actual_total = preciseSubtract(v2, v1)
      if (this.formData.is_by_stages_again && this.formData.money_actual) {
        this.onAmountChange(this.formData.money_actual)
        this.$refs.ruleForm.validateField('money_actual')
        this.$refs.ruleForm.validateField('money_to_pay')
      }
    },
    onStageChange() {
      this.formData.money_actual = ''
      this.formData.money_to_pay = ''
      this.formData.money_installment_average = ''
      this.formData.money_installment_count = ''
      this.formData.money_installment_count = ''
      this.installmentConfig = []
      this.installmentData = []
    },
    onAmountChange(val) {
      if (verifyIsNumber(val, { empty: '请输入本期实缴金额', positive: true })) {
        this.formData.money_to_pay = ''
        return
      }
      let v1 = Number(val)
      let v2 = Number(this.formData.is_offline_discount ? this.formData.money_answer_actual_total : this.money_answer)
      if (v1 > v2) {
        this.formData.money_to_pay = ''
        return
      }
      this.formData.money_to_pay = preciseSubtract(v2, v1)
      this.$refs.ruleForm.validateField('money_to_pay')
      if (this.formData.money_installment_average) {
        this.$refs.ruleForm.validateField('money_installment_average')
        this.onInstallmentChange(this.formData.money_installment_average)
      }
    },
    onInstallmentChange(val) {
      const v = verifyIsNumber(val, { positive: true  })
      if (v) {
        this.formData.money_installment_count = ''
        this.installmentConfig = []
        this.installmentData = []
        return
      }
      const v1 = Number(this.formData.money_to_pay)
      const v2 = Number(val)
      if (v2 <= 0 || v2 >= v1) {
        this.formData.money_installment_count = ''
        this.installmentConfig = []
        this.installmentData = []
        return
      }
      const n = Math.ceil(v1/v2)
      this.formData.money_installment_count = n + 1
      this.changeInstallmentData()
    },
    changeInstallmentData() {
      const len1 = Number(this.formData.money_installment_count)
      if (!len1 || len1 > 12) return
      const len = len1 - 1
      const total = Number(this.formData.money_to_pay)
      const unit = Number(this.formData.money_installment_average)
      const v1 = Number(this.formData.money_actual)
      const num = preciseDivide(total, unit)
      const v3 = len === num ? unit : preciseSubtract(total, preciseMultiply(unit, len - 1))
      const arr1 = []
      const obj = {}
      for (let i = 0; i <= len; i++) {
        const key = `K_${i}`
        obj[key] = i ? i === len ? v3 : unit : v1
        arr1.push({ label: numberToChinese(i+1, true)+'期', prop: key, type: 'title' })
      }
      arr1.push({ label: '合计', prop: `K_${len+1}`, type: 'title' })
      obj[`K_${len+1}`] = preciseAdd(total, this.formData.money_actual)
      this.installmentConfig = arr1
      this.installmentData = [obj]
    },
    handleAction(row) {
      const data = { order_id: row.order_id, detail_ids: row.detail_ids, installment_order_id: row.installment_order_id, installment_num: row.installment_num }
      this.loading = true
      http({ url: '/finance/installment-pay/order-approve-view-v2', pre: 'zs' }, data).then(res => {
        if (row.action.type === 'view') {
          this.handleView(res)
        } else if (row.action.type === 'approval') {
          // this.info = res
          this.info = {
            category_name: res.category_name,
            order_id: res.order_id,
            detail_ids: res.detail_ids,
            installment_order_id: res.installment_order_id,
            installment_num: res.installment_num,
            installment_count: res.installment_count,
            pay_status: res.pay_status,
            pay_status_txt: res.pay_status_txt,
            pay_time: res.pay_time,
            pay_mode: res.pay_mode,
            reason: res.reason,
          }
          this.handleApprove(res)
        }
      }).finally(() => this.loading = false)
    },
    handleApprove(res) {
      this.approveVisible = true
      this.money_answer = Number(res.money_answer)
      this.status_text = res.pay_status_txt
      const name = res.category_name + (res.installment_count > 1 ? `(${res.installment_num}/${res.installment_count})` : '')
      this.category_name = name
      const payment_detail = res.payment_detail || []
      this.formData = {
        is_offline_discount: res.money_offline_discount ? 1 : 0,
        money_offline_discount: res.money_offline_discount,
        money_answer_actual_total: res.money_answer_actual_total,
        money_installment_average: res.money_installment_average || '',
        money_installment_count: res.money_installment_count || '',
        is_by_stages_again: res.is_by_stages_again,
        money_actual: Number(res.money_actual),
        money_to_pay: Number(res.money_to_pay),
        pay_time: formatDate().fullDateTime,
        payment_detail,
        reason: res.reason
      }
      if (this.formData.is_by_stages_again === 2) {
        this.changeInstallmentData()
      }
      if (!payment_detail.length) this.handleAdd()
      // this.$refs.form.resetFields()
    },
    handleView(res) {
      this.viewList1 = []
      this.viewList2 = []
      this.viewList3 = []
      this.viewData = []
      this.dialogConfig = []
      this.dialogData = []
      this.viewVisible = true
      const stagesMap = ['否', '部分欠缴', '按期缴费']
      const payment_detail = res.payment_detail || []
      let list1 = []
      const name = res.category_name + (res.installment_count > 1 ? `(${res.installment_num}/${res.installment_count})` : '')
      if (payment_detail.length) {
        const isY = Number(res.money_offline_discount)
        list1 = [
          { label: '订单状态', value: res.pay_status_txt , color: '#23C343' },
          { label: '缴费方式', value: res.pay_mode_txt , cssStyle: {'grid-column': '2 / -1' } },
          { label: '分期项', value: name },
          { label: '本期应缴金额', value: res.money_answer },
          { label: '是否有特批优惠', value: isY ? '是' : '否' },
          ...(isY ? [{ label: '特批优惠金额', value: res.money_offline_discount }, { label: '实际应缴金额', value: res.money_answer_actual_total }] : []),
          { label: '是否再次分期', value: stagesMap[res.is_by_stages_again] },
          { label: '本期实缴金额', value: res.money_actual },
          ...(res.is_by_stages_again ? [{ label: '欠缴金额', value: res.money_to_pay }] : []),
          ...(res.is_by_stages_again === 2 ? [{ label: '分期每期应缴金额', value: res.money_installment_average }, { label: '分期期数', value: res.money_installment_count }] : []),
          // { label: '缴费时间', value: res.pay_time }
        ]
        if (res.is_by_stages_again === 2 && res.money_installment_count) { 
          const len1 = Number(res.money_installment_count)
          if (!len1 || len1 > 12) return
          const len = len1 - 1
          const total = Number(res.money_to_pay)
          const unit = Number(res.money_installment_average)
          const v1 = Number(res.money_actual)
          const num = preciseDivide(total, unit)
          const v3 = len === num ? unit : preciseSubtract(total, preciseMultiply(unit, len - 1))
          const arr1 = []
          const obj = {}
          for (let i = 0; i <= len; i++) {
            const key = `K_${i}`
            obj[key] = i ? i === len ? v3 : unit : v1
            arr1.push({ label: numberToChinese(i+1, true)+'期', prop: key, type: 'title' })
          }
          arr1.push({ label: '合计', prop: `K_${len+1}`, type: 'title' })
          obj[`K_${len+1}`] = preciseAdd(total, res.money_actual)
          this.dialogConfig = arr1
          this.dialogData = [obj]
        }
      } else {
        list1 = [
          // { label: '订单状态', value: res.pay_status_txt , cssStyle: {'grid-column': '1 / -1' }, color: '#23C343' },
          { label: '订单状态', value: res.pay_status_txt , color: '#23C343' },
          { label: '缴费方式', value: res.pay_mode_txt , cssStyle: {'grid-column': '2 / -1' } },
          { label: '分期项', value: name },
          { label: '本期应缴金额', value: res.money_actual },
          { label: '本期实缴金额', value: res.money_actual },
          { label: '支付方式', value: res.pay_mode_txt },
          { label: '付款人姓名', value: res.customer_name },
          { label: '支付时间', value: res.pay_time }
        ]
      }
      // 订单信息
      this.viewList1 = list1
      if (!payment_detail.length) return
      const list2 = []
      if (res.reason) {
        list2.push({ label: '备注', value: res.reason, cssStyle: {'grid-column': '1 / 3' } })
      }
      // 备注
      this.viewList2 = list2
      // 操作记录
      this.viewList3 = [
        { label: '操作人', value: res.approval_creator },
        { label: '操作时间', value: res.approval_at, cssStyle: {'grid-column': '2 / -1' }},
      ]
      // 实缴金额及方式
      this.viewConfig = [
        { prop: 'paid_amount', label: '学生缴费金额', type: 'other' },
        { prop: 'payment_method', label: '学生缴费方式', type: 'other' },
        { prop: 'payer', label: '付款人姓名', type: 'other' },
        { prop: 'payment_at', label: '缴费时间', type: 'other' }
      ]
      if (payment_detail.length === 1 && Number(payment_detail[0].paid_amount) === 0) return
      this.viewData = res.payment_detail
      const sum = this.viewData.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount) || 0), 0)
      this.viewSumAmount = `累计实缴金额：${sum}`
    },
    getConfig() {
      this.typeOptions = orderPayMethod()
    },
    getData() {
      const id = this.$route.query.id
      if (!id) return
      this.id = id
      this.loading = true
      http({ url: '/finance/installment-pay/order-view-v2', pre: 'zs' }, { order_id: id }).then(res => {
        const { order_type, year, method, tag = [] } = res
        this.tag = tag
        const list = [
          { label: '否', value: 0 },
          { label: '部分欠缴', value: 1 }
        ]
        if (order_type === 2 && year >= 2026 && method !== 2) {
          this.is2026Order = true
          list.push({ label: '按期缴费', value: 2 })
        }
        this.stagesOptions = list
        const stageMap = ['不分期', '明细分期', '部分欠缴']
        const stage_name = stageMap[res.is_by_stages]
        // 1: '预报名订单'
        // 2: '正式报名订单'
        // 3: '在校生续费订单'
        // 4: '复读生正式报名订单'
        // 5: '保过订单',
        // 7: '转学生正式报名订单',
        // 8: '其他费用缴纳',
        // 100: '其他费用缴纳',
        if ([3, 100].includes(order_type)) {
          const list1 = [
            { label: '订单编号', value: res.order_number },
            { label: '入账学校', value: res.school },
            { label: '订单类型', value: res.order_type_name },
            { label: '学生姓名', value: res.student_name },
            { label: '学生身份证号/护照号', value: res.student_idcard },
            { label: '缴费学年', value: res.school_year },
            { label: '就读年级', value: res.grade_name },
            { label: '行政班', value: res.class_name },
            { label: '就读校区', value: res.studying_school_name }
          ]
          if (order_type === 100) {
            list1.push({ label: '购买服务名称/收费项名称', value: res.goods_pack_name })
          }
          const list2 = [
            { label: '实际应缴总额', value: res.money_answer_actual_total },
            { label: '实际支付总额', value: res.money_actual },
            { label: '分期方式', value: stage_name },
            { label: '欠缴总额', value: res.money_to_pay }
          ]
          this.list1 = list1
          this.list2 = list2
        } else if ([2, 4, 7].includes(order_type)) {
          const list1 = [
            { label: '订单编号', value: res.order_number },
            { label: '入账学校', value: res.school },
            { label: '购买服务名称', value: res.goods_pack_name },
            { label: '学生姓名', value: res.student_name },
            { label: '学生身份证号/护照号', value: res.student_idcard },
            { label: '报名年级', value: res.grade_name },
            { label: '学习方向', value: res.study_type_name },
            { label: '专业方向', value: res.major_name },
            { label: '当前客户归属招生老师', value: res.belong_teacher },
            { label: '是否参与预报名', value: res.is_pre_register, button: res.is_pre_register === '是' ? '查看详情' : '', type: 2 }
          ]
          if (res.is_pre_register === '是') {
            list1.push({ label: '预报名支付金额', value: res.pre_register_amount })
          }
          if (res.max_score_name === '中考') {
            list1.push({ label: '中考成绩折算后总分', value: res.max_score })
            list1.push({ label: '中考成绩截图', value: res.score_image ? '' : '-', button: res.score_image ? '查看成绩截图' : '', type: 0 })
            this.score_image = res.score_image
          } else {
            list1.push({ label: '最高诊断性考试折算后总分', value: res.max_score, button: '查看详情', type: 1 })
            this.dialogList = [
              { label: '学生姓名', value: res.student_name },
              { label: '学生参考城市', value: res.senior_city },
              { label: '考试名称', value: res.max_score_name },
              { label: '考试总分', value: res.junior_score },
              { label: '折算后考试总分', value: res.max_score }
            ]
            const options = [], arr = res.diagnose_score_list || [], l1 = arr[0]?.length
            if (l1) {
              for (let i = 0; i < l1; i++) {
                options.push({ label: arr[0][i], value: arr[1][i] })
              }
            }
            let l2 = options.length
            if (l2 > 3) {
              l2 = Math.ceil(l2 / 2)
            }
            const obj1 = {num: '分数'}, obj2 = {num: '分数'}, config1 = [{ label: '科目', prop: 'num', type: 'title' }], config2 = [{ label: '科目', prop: 'num', type: 'title' }]
            options.forEach((i, index) => {
              if (index < l2) {
                obj1[`k_${index}`] = i.value
                config1.push({ prop: `k_${index}`, label: i.label })
              } else {
                obj2[`k_${index}`] = i.value
                config2.push({ prop: `k_${index}`, label: i.label })
              }
            })
            this.dialogListData1 = [obj1]
            this.dialogListConfig1 = config1
            if (config2.length > 1) {
              const l3 = config1.length - config2.length
              if (l3 > 0) {
                for (let i = 0; i < l3; i++) {
                  config2.push({ prop: `z_${i}`, label: '' })
                }
              }
              this.dialogListData2 = [obj2]
              this.dialogListConfig2 = config2
            }
          }
          this.list1 = list1
          const pre_register = res.pre_register || []
          this.dialogListData3 = pre_register.map(i => ({
            order_number: i.order_number,
            belong_teacher_name: i.belong_teacher_name,
            money_answer: i.money_answer,
            money_actual: i.money_actual,
            pay_time: i.pay_time || '-'
          }))
          this.dialogListConfig3 = [
            { prop: 'order_number', label: '预报名订单号' },
            { prop: 'belong_teacher_name', label: '预报名客户归属人' },
            { prop: 'money_answer', label: '应缴金额' },
            { prop: 'money_actual', label: '实缴金额' },
            { prop: 'pay_time', label: '支付时间' }
          ]
          const list2 = [
            { label: '系统计算应缴总额', value: res.money_answer },
            { label: '特批优惠总额', value: res.money_offline_discount },
            { label: '分期方式', value: stage_name },
            { label: '实际应缴总额', value: res.money_answer_actual_total },
            { label: '实际支付总额', value: res.money_actual },
            { label: '欠缴总额', value: res.money_to_pay }
          ]
          this.list2 = list2
        }
        const config = [
          { prop: 'order_number', label: '订单编号' },
          { prop: 'status', label: '订单状态' },
          { prop: 'answer_price', label: '应缴金额' },
          { prop: 'price', label: '实缴金额' },
          { prop: 'pay_time', label: '缴费时间' },
          { prop: 'action', label: '操作' }
        ]
        const arr1 = res.order_plan || [], arr2 = [], header = []
        const statusMap = {
          0: { status: '待支付', text: '', type: '' },
          1: { status: '已支付', text: '查看', type: 'view' },
          2: { status: '已取消', text: '', type: '' },
          101: { status: '待支付', text: '审批', type: 'approval', color: '#FF7231' },
        }
        let isLog = false
        const typeLen = arr1.length
        arr1.map((o) => {
          const goods_name = o.goods_category_name
          if (!isLog) {
            if (goods_name) {
              isLog = true
            }
            if (!header.length) {
              if (goods_name) {
                header.push(...[
                  { prop: 'goods_name', label: '缴费项目', width: 150 },
                  { prop: 'name', label: '分期项' },
                ])
              } else {
                header.push(...[
                  { prop: 'goods_name', label: '分期计划', width: 150 },
                  { prop: 'name', label: '分期项' },
                ])
              }
            }
          }
          let len1 = o.group_detail.reduce((a, b) => (a + (b?.length || 0)), 0)
          o.group_detail.map((p, x) => {
            const len2 = p.length
            p.map((i, y) => {
              const sd = statusMap[i.pay_status]
              const obj = {
                id: i.id,
                order_id: i.order_id,
                detail_ids: i.detail_ids,
                installment_order_id: i.installment_order_id,
                installment_num: i.installment_num,
                order_number: i.installment_order_number,
                status: sd.status,
                answer_price: Number(i.answer_price),
                price: Number(i.price),
                pay_time: i.pay_status === 1 ? i.pay_time : '',
                action: sd,
                active: i.pay_status === 101 ? true : false
              }
              const isShow = i.installment_count !== 1 ? true : false
              const showText = `(${i.installment_num}/${i.installment_count})`
              if (goods_name) {
                obj.goods_name = goods_name
                obj.name = isShow ? `${i.category_name}${showText}` : '-'
              } else {
                obj.goods_name = numberToChinese(x+1, true)+'期'
                obj.name = isShow ? `分期${showText}` : '-'
              }
              // 有多个缴费项目时，goods_name显示缴费项目 并且合并列
              if (typeLen > 1 && len1 > 1) {
                if (x === 0) {
                  obj.rowspan = len1
                  obj.rowKey = 'goods_name'
                } else {
                  obj.hide = 'goods_name'
                }
              }
              // 有多个分期项时，合并分期项列
              if (len2 > 1) {
                if (y === 0) {
                  obj.secondRowSpan = len2
                  obj.secondRowKey = 'name'
                } else {
                  obj.secondHide = 'name'
                }
                // 有多个分期项时，合并goods_name列与分期项一致
                // if (typeLen === 1) {
                  if (y === 0) {
                    if (!obj.rowspan) obj.rowspan = len2
                    obj.rowKey = 'goods_name'
                  } else {
                    obj.hide = 'goods_name'
                  }
                // }
              }
              arr2.push(obj)
            })
          })
        })
        const s1 = arr2.reduce((pre, cur) => preciseAdd(pre, cur.answer_price || 0), 0)
        const s2 = arr2.reduce((pre, cur) => preciseAdd(pre, cur.price || 0), 0)
        arr2.push({ goods_name: '合计', answer_price: s1, price: s2 })
        this.data = arr2
        this.config = [...header, ...config]
      }).finally(() => this.loading = false)
    },
    handlePreview(type) {
      if (type === 0) {
        this.imageVisible = true
      } else {
        const arr = {
          1: '最高诊断性考试成绩详情',
          2: '预报名订单'
        }
        this.title = arr[type]
        this.dialogVisible = true
        this.dialogType = type
      }
    },
    handleAdd() {
      if (this.dynamicMaxlength <= this.formData.payment_detail.length) {
        return this.$message.warning(`最多只能添加${this.dynamicMaxlength}条`);
      }
      this.formData.payment_detail.push({ id: Date.now(), payment_method:'', paid_amount: '', payer: '', payment_at: formatDate().fullDateTime, isAdd: 1 })
    },
    handleDelete(item) {
      const index = this.formData.payment_detail.indexOf(item)
      if (!~index) return
      this.formData.payment_detail.splice(index, 1)
    },
    handelRemove(item) {
      const { id, ...other } = item
      if(objectIsEmpty(other, ['isAdd'])) return this.handleDelete(item)
      this.$confirm('此操作将删除该项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, _instance, done) => {
          if (action === 'confirm') this.handleDelete(item)
          done()
        }
      }).then(() => {
        this.$message({ type: 'success', message: `删除成功!` })
      })
    },
    onBeforeClose(done, instance) {
      done()
      this.getData()
    },
    onClose() {
      this.approveVisible = false
      this.getData()
    },
    submit(formName, save = true) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const { is_by_stages_again } = this.formData
          const arr = this.formData.payment_detail.filter(i => i.paid_amount)
          const sum = arr.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount)), 0)
          // const num = is_by_stages_again ? Number(this.formData.money_actual) : Number(this.money_answer)
          let num = 0
          if (this.formData.is_offline_discount) {
            num = is_by_stages_again ? Number(this.formData.money_actual) : Number(this.formData.money_answer_actual_total)
          } else {
            num = is_by_stages_again ? Number(this.formData.money_actual) : Number(this.money_answer)
          }
          let msg = ''
          if (this.showMethod && num !== sum) msg = `学生【实缴金额及方式】的累计实缴金额需等于【本期实缴金额】`
          if (msg) return this.$message.error({ message: msg, duration: 4000 })
          if (msg) return this.$message.error({ message: msg, duration: 4000 })
          this.handleConfirm(save)
        }
      })
    },
    handleConfirm(save = true) {
      const id = this.$route.query.id
      const { payment_detail, is_offline_discount, money_to_pay, money_actual, is_by_stages_again, money_offline_discount, money_answer_actual_total, money_installment_average, money_installment_count, ...other } = this.formData
      const data = { ...this.info, ...other, id, is_by_stages_again }
      data.payment_detail = this.showMethod ? transformAddOrEditData(payment_detail) : [
        {
          payment_method: '现金',
          paid_amount: 0,
          payer: '/',
          payment_at: formatDate().fullDateTime
        }
      ]
      data.payment_at = data.payment_detail[0].payment_at
      const num = Number(is_by_stages_again ? money_actual : this.money_answer)
      data.money_answer = this.money_answer
      data.money_actual = num
      data.money_to_pay = is_by_stages_again ? money_to_pay : 0
      if (is_offline_discount) {
        data.money_offline_discount = money_offline_discount
        data.money_answer_actual_total = money_answer_actual_total
        if (!is_by_stages_again) {
          data.money_actual = money_answer_actual_total
        }
      } else {
        data.money_offline_discount = 0
        data.money_answer_actual_total = this.money_answer
      }
      if (is_by_stages_again === 2) {
        data.money_installment_average = money_installment_average
        data.money_installment_count = money_installment_count
        data.money_installment_first = num
        const key = this.installmentConfig[money_installment_count - 1].prop
        data.money_installment_last = this.installmentData[0][key]
      }
      const url = `/finance/installment-pay/order-approve-${save ? `do-v${this.is2026Order ? 3 : 2}` : 'cache'}`
      this.approveLoading = true
      http({ url, pre: 'zs', method: 'post'}, data).then(() => {
        this.approveLoading = false
        this.approveVisible = false
        this.getData()
      }).catch(() => this.approveLoading = false)
    }
  }
}
</script>

<style lang="scss" scoped>

.table-wrap {
  padding-top: 30rem;
  margin-top: 10rem;
  border-top: dashed 1rem #F09D12;
}
</style>
